/**
 * Card Grid
 */

import './_card-grid.twig';

export const name = 'card-grid';

export function disable() {}

export function enable() {}

export default enable;
